// Contracts for «Firecrackers» (firecrackers, 鞭炮): a single-player 5×5 grid game (mines) on the user's seed pair.
//   GET  /api/firecrackers/state                        → FcStateResponse
//   POST /api/firecrackers/start   body FcStartInput     → FcActionResponse
//   POST /api/firecrackers/reveal  body FcRevealInput    → FcActionResponse
//   POST /api/firecrackers/cashout body FcCashoutInput   → FcActionResponse
import { z } from 'zod';
import { zAmount, zIdempotencyKey } from '../common';
import type { FairProof } from '../fair';

export const FC_CELLS = 25;
export const FC_MIN_MINES = 1;
export const FC_MAX_MINES = 24;
export const FC_MINE_PRESETS = [1, 3, 5, 8, 13, 18] as const;

export const zFcStartInput = z.object({ bet: zAmount, mines: z.number().int().min(FC_MIN_MINES).max(FC_MAX_MINES), idempotencyKey: zIdempotencyKey }).strict();
export const zFcRevealInput = z.object({ gameId: z.string().min(1).max(64), step: z.number().int().min(1).max(FC_CELLS - 1), cell: z.number().int().min(0).max(FC_CELLS - 1) }).strict();
export const zFcCashoutInput = z.object({ gameId: z.string().min(1).max(64) }).strict();
export type FcStartInput = z.infer<typeof zFcStartInput>;
export type FcRevealInput = z.infer<typeof zFcRevealInput>;
export type FcCashoutInput = z.infer<typeof zFcCashoutInput>;

export type FcStatus = 'active' | 'lost' | 'cashed';

export interface FcGameView {
  gameId: string;
  betId: string;
  mines: number;
  bet: number;
  step: number;            // открыто слитков
  picks: number[];         // открытые клетки по порядку (последняя — хлопушка, если lost)
  status: FcStatus;
  multiplier: number;      // 0 до первого слитка и при проигрыше
  payout: number;
  layout: number[] | null; // клетки с хлопушками — только когда status !== 'active'
}

export interface FcStateResponse {
  game: FcGameView | null;
  fair: { serverSeedHash: string; clientSeed: string; nonce: number };
  cells: number; minBet: number; maxBet: number; maxWin: number;
}

export interface FcActionResponse { game: FcGameView; balance: number; fair: FairProof; duplicate: boolean }
export interface FcBetContext { mines: number; picks: number[]; layout: number[] | null }
